
export function isOnLastPage(currentBookmark: string | null | undefined, lastBookmark: string | null | undefined){
    if (currentBookmark === 'nil'){
        return true;
    }
    if (currentBookmark && lastBookmark && currentBookmark === lastBookmark){
        return true;
    }
    return false;
}